<header name="language-switch-button" attr.data-env="{{env}} | {{build}}">
    <nav class="navbar">

        <ul class="navbar-nav">
            <!-- mobile -->
            <div class="d-md-none dropdown-divider"></div>
            <li class="nav-item d-md-none">
                <a name="language-switch-mobile" (click)="openLanguageSwitchModal()"
                    class="nav-link text-nowrap justify-content-between">
                    <span>
                        Language - <span class="OneLinkNoTx">{{selectedLanguageLabel}}</span>
                    </span>
                    <i class="jr-icon chevron-right"></i>
                </a>
            </li>

            <!-- desktop -->
            <li dropdown class="nav-item dropdown d-none d-md-flex" [autoClose]="false">
                <a dropdownToggle #toggle name="dropdown-toggle" class="OneLinkNoTx nav-link dropdown-toggle" aria-controls="dropdown-lang"
                    id="languageDropdown" role="button">
                    <i class="jr-icon earth color-bg-brand-3 mr-1"></i>
                    {{selectedLanguageLabel}}
                </a>
                <div *dropdownMenu id="dropdown-lang" #menu class="dropdown-menu align-right"
                    aria-labelledby="languageDropdown">
                    <a (click)="selectLanguage('EN'); toggle.click()" name="en" [ngClass]="{'active': isCurrentLanguage('EN')}"
                        class="OneLinkNoTx dropdown-item">English</a>
                    <a (click)="selectLanguage('ES'); toggle.click()" name="es" [ngClass]="{'active': isCurrentLanguage('ES')}"
                        class="OneLinkNoTx dropdown-item">Español</a>
                </div>
            </li>
        </ul>

    </nav>
</header>
